export enum LocalStorageKeys {
  IS_INSTITUTIONS_LIST_EXPANDED = 'IS_INSTITUTIONS_LIST_EXPANDED',
  IS_CONTACTS_LIST_ON_CONTACTS_PAGE_EXPANDED = 'IS_CONTACTS_LIST_ON_CONTACTS_PAGE_EXPANDED',
  IS_CONTACTS_LIST_ON_PARENT_PAGE_EXPANDED = 'IS_CONTACTS_LIST_ON_PARENT_PAGE_EXPANDED',
  IS_CONTACTS_LIST_ON_CHILD_PAGE_EXPANDED = 'IS_CONTACTS_LIST_ON_CHILD_PAGE_EXPANDED',
  IS_DOMAINS_LIST_ON_DOMAINS_PAGE_EXPANDED = 'IS_DOMAINS_LIST_ON_DOMAINS_PAGE_EXPANDED',
  IS_SEARCH_HISTORY_PANEL_OPEN = 'IS_SEARCH_HISTORY_PANEL_OPEN',
  IS_INSTITUTIONS_SEARCH_HISTORY_PANEL_OPEN = 'IS_INSTITUTIONS_SEARCH_HISTORY_PANEL_OPEN',
  SEARCH_HISTORY_COLLAPSED_SECTIONS = 'SEARCH_HISTORY_COLLAPSED_SECTIONS',
  IS_SIDEBAR_VISIBLE = 'IS_SIDEBAR_VISIBLE',
}

export class LocalStorageService {

  private static defaults: Record<LocalStorageKeys, any> = {
    [LocalStorageKeys.IS_INSTITUTIONS_LIST_EXPANDED]: false,
    [LocalStorageKeys.IS_CONTACTS_LIST_ON_CONTACTS_PAGE_EXPANDED]: false,
    [LocalStorageKeys.IS_CONTACTS_LIST_ON_PARENT_PAGE_EXPANDED]: false,
    [LocalStorageKeys.IS_CONTACTS_LIST_ON_CHILD_PAGE_EXPANDED]: false,
    [LocalStorageKeys.IS_DOMAINS_LIST_ON_DOMAINS_PAGE_EXPANDED]: false,
    [LocalStorageKeys.IS_SEARCH_HISTORY_PANEL_OPEN]: true,
    [LocalStorageKeys.IS_INSTITUTIONS_SEARCH_HISTORY_PANEL_OPEN]: true,
    [LocalStorageKeys.SEARCH_HISTORY_COLLAPSED_SECTIONS]: {},
    [LocalStorageKeys.IS_SIDEBAR_VISIBLE]: true,
  }

  // Method to get the value from localStorage or the default
  static get<T>(key: LocalStorageKeys): T {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) {
      return this.defaults[key] as T;
    }
    try {
      const parsedValue = JSON.parse(storedValue);
      // Handle legacy string boolean values (e.g., "true" or "false" as strings)
      if (parsedValue === 'true') return true as T;
      if (parsedValue === 'false') return false as T;
      return parsedValue as T;
    } catch (e) {
      console.error(`Error parsing localStorage value for key: ${key}`, e);
      return this.defaults[key] as T;
    }
  }

  static getCustom(key: string, defaultValue: string) {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) {
      return defaultValue
    }
    try {
      return JSON.parse(storedValue);
    } catch (e) {
      console.error(`Error parsing localStorage value for key: ${key}`, e);
      return defaultValue;
    }
  }

  // Method to set the value in localStorage
  static set<T>(key: LocalStorageKeys, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Error setting localStorage value for key: ${key}`, e);
    }
  }

  static setCustom(key: string, value: string): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Error setting localStorage value for key: ${key}`, e);
    }
  }
}
